import { render, staticRenderFns } from "./SettingsRationModal.vue?vue&type=template&id=23e8057d&scoped=true&lang=pug"
import script from "./SettingsRationModal.vue?vue&type=script&lang=js"
export * from "./SettingsRationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8057d",
  null
  
)

export default component.exports